<template>
  <v-container fluid class="timereport-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn 
                color="success" 
                class="button-shadow mr-3"
                @click="findTimeReportDialog = true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <v-btn 
                v-show="timereports.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
                @click="printItem"
              >
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
                <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'">
                <v-text-field
                  dense
                  :full-width=$vuetify.breakpoint.smAndDown
                  outlined
                  hide-details
                  label="Search"
                  prepend-inner-icon="mdi-magnify"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-end mt-3">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="timereports-table"
              show-select
              single-select
              item-key="_id"
              sort-by="timereportname"
              :footer-props="footer"
              :headers="headers"
              :items="timereports"
              :items-per-page="itemPerPage">
              <template v-slot:item.imagein="{ item }">
                  <img v-if="item.imagein" v-bind:src="item.imagein" alt="" width="60">
                  <img v-if="item.imageout" v-bind:src="item.imageout" alt="" width="60">
              </template>
              <template v-slot:item.workhours="{ item }">
                {{ item.workhours!==null ? (item.workhours-offset).toFixed(2) : '' }}
              </template>
              <template v-slot:item.timein="{ item }">
                <p class="two-line">{{ item.timein!=null ? new Date(item.timein).toLocaleTimeString("en-SG", { timeZone: 'UTC' }) : '' }}</p>
                <p class="two-line">{{ item.timeout!=null ? new Date(item.timeout).toLocaleTimeString("en-SG", { timeZone: 'UTC' }) : '' }}</p>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="findTimeReportDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Employee</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="employees.filter(x=>x.employeestatus=='Active').map(x => {
                            return {text: x.employeename, value: x._id};
                          })"
                  v-model="query.employeeid"
                  label="Employee"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="findTimeReportDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findTimeReport"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TimeReportList',
  data() {
    return {
      headers: [
        { text: 'Image', value: 'imagein' },
        { text: 'Name', value: 'employeename' },
        { text: 'Date', value: 'date' },
        { text: 'Time In & Out', value: 'timein' },
        { text: 'Hours', value: 'workhours' },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      findTimeReportDialog: false,
      query: {},
      timereports: [],
      menu_startdate: null,
      menu_enddate: null,
      offset: 0,
    }
  },
  computed: {
    ...mapState('Employee', ['employees',]),
    ...mapState('TimeTracking', ['timetrackings', 'isReceiving', 'isDeleting', 'isUpdating']),
  },
  created () {
    if(this.employees.length==0) this.getEmployeesRequest();
    let companyid = localStorage.getItem('companyid');
    if(companyid=='60a8acb67418a3429476cd42') this.offset = 1;
    else if(companyid=='60b07f300d820029acae4734') this.offset = 0.5;
  },
  methods: {
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions('TimeTracking', ["getTimeReportRequest"]),
    async findTimeReport(){
      this.findTimeReportDialog = false;
      let result = await this.getTimeReportRequest(this.query);
      console.log(result);
      this.timereports = result;
    },
    printItem() {
      let item = Object.assign({}, this.query);
      item.timereports = this.timereports;
      this.$router.push({ name: 'TimeReportPrint', params: item })
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
